import { useEffect } from "react";
import { trackEvent } from "services/analytics.service";
import { AnalyticsEvent } from "services/analyticsEvents";

// Below this, a cleanup firing is almost certainly React StrictMode's
// dev-only mount→cleanup→mount double-invoke on initial mount, not a real
// screen view — no genuine user ever sees a screen for less time than this.
const MIN_MEANINGFUL_DURATION_MS = 100;

// Fires the given screen-specific TIME_ON_*_SCREEN event once, when the
// screen unmounts (navigated away from) — one event name per screen (see
// analyticsEvents.ts) instead of one generic event with a screen_name
// param, so each screen's dwell time reads unambiguously in reports.
export function useScreenTimeTracking(event: AnalyticsEvent): void {
  useEffect(() => {
    const enteredAt = Date.now();
    return () => {
      const duration_ms = Date.now() - enteredAt;
      if (duration_ms < MIN_MEANINGFUL_DURATION_MS) return;
      trackEvent(event, { duration_ms });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
